// Contar contratos por estado
export const contractStates = (contracts) =>
  contracts.reduce((acc, contract) => {
    acc[contract.state] = (acc[contract.state] || 0) + 1;
    return acc;
  }, {});
// Contar contratos por área
export const contractAreas = (contracts) =>
  contracts.reduce((acc, contract) => {
    acc[contract.userArea] = (acc[contract.userArea] || 0) + 1;
    return acc;
  }, {});

// Contar contratos por mes
export const contractMonths = (contracts) =>
  contracts.reduce((acc, contract) => {
    const month = new Date(contract.contractDate).toLocaleString('default', { month: 'short' });
    if (month === 'Invalid Date') {
      acc['Sin fecha'] = (acc['Sin fecha'] || 0) + 1;
    } else {
      acc[month] = (acc[month] || 0) + 1;
    }

    return acc;
  }, {});

// Clasificación de contratos: Próximos a vencer, vencidos y otros
export const contractClasification = (contracts) => {
  const today = new Date();
  let upcoming = 0;
  let expired = 0;
  let current = 0;

  contracts.forEach((contract) => {
    const expiration = new Date(contract.expirationDateTimestamp * 1000);
    const diffDays = (expiration - today) / (1000 * 60 * 60 * 24);
    if (diffDays < 0) {
      expired += 1;
    } else if (diffDays <= 15) {
      upcoming += 1;
    } else {
      current += 1;
    }
  });
  return [expired, upcoming, current];
};
// Clasificación de contratos: Próximos a vencer, vencidos y vigentes x area usuaria

export const contractClasificationByArea = (contracts) => {
  const today = new Date();
  const result = {};
  contracts.forEach((contract) => {
    const expiration = new Date(contract.expirationDateTimestamp * 1000);
    const diffDays = (expiration - today) / (1000 * 60 * 60 * 24);

    // clasification by date
    let status = '';
    if (diffDays < 0) {
      status = 'expired';
    } else if (diffDays <= 15) {
      status = 'upcoming';
    } else {
      status = 'current';
    }

    // add area
    if (!result[contract.userArea]) {
      result[contract.userArea] = { expired: 0, upcoming: 0, current: 0 };
    }

    // add status x area
    result[contract.userArea][status] += 1;
  });
  return result;
};

export const filterByTipeAndValue = (contracts, type, value, isFirstSection) => {
  if (!contracts) return [];
  if (isFirstSection) {
    return contracts.filter((item) => item[type] === value);
  }

  const today = new Date();
  return contracts
    .filter((item) => {
      const expiration = new Date(item.expirationDateTimestamp * 1000);
      const diffDays = (expiration - today) / (1000 * 60 * 60 * 24);

      if (value === 'Vencidos') {
        return diffDays < 0;
      }
      if (value === 'Próximos a Vencer') {
        return diffDays <= 15 && diffDays >= 0;
      }
      if (value === 'Vigentes') {
        return diffDays > 15;
      }
      return true;
    })
    .filter((item) => (type ? item.userArea === type : true));
};
